import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { space, device, Tooltip, Button, H2, color } from '@ticketswap/solar'
import { Plus, Minus } from '@ticketswap/comets'

const Selector = styled.div`
  width: 50%;
  display: flex;
  align-items: center;

  button {
    width: ${space[44]};
    height: ${space[44]};
  }

  @media ${device.tablet} {
    width: 33.3%;
    width: calc(100% / 3);

    button {
      width: ${space[56]};
      height: ${space[56]};
    }
  }

  [data-theme='dark'] & {
    button {
      background-color: ${color.earth};
      color: ${color.space};

      &:hover,
      &:active {
        background-color: ${color.earthLight};
        color: ${color.space};
      }
    }
  }
`

const Quantity = styled.div`
  font-variant-numeric: tabular-nums;
  padding-left: ${space[8]};
  padding-right: ${space[8]};

  @media ${device.tablet} {
    padding-left: ${space[16]};
    padding-right: ${space[16]};
  }
`

const QuantitySelector = ({
  quantity,
  isBundledTickets,
  setQuantity,
  numberOfTicketsInListing,
  showScarcityAlert,
  numberOfAvailableTickets,
  t,
  numberOfTicketsStillForSale,
}) => (
  <Selector>
    <Button
      type="button"
      size="small"
      variant="secondary"
      disabled={isBundledTickets || quantity === 1}
      onClick={() => setQuantity(qty => Math.max(1, qty - 1))}
      leftAdornment={<Minus />}
    />
    <Quantity>
      <H2 as="span">{quantity}</H2>
    </Quantity>
    <Tooltip
      label={
        isBundledTickets
          ? t('listing:purchaser.bundledTickets.tooltip')
          : showScarcityAlert
          ? t('listing:purchaser.scarcityAlert', {
              x: numberOfAvailableTickets,
              y: numberOfTicketsInListing,
            })
          : t('listing:purchaser.availableTickets', {
              count: numberOfAvailableTickets,
            })
      }
    >
      {/* This div makes sure that the tooltip will show even if the button is disabled */}
      <div>
        <Button
          disabled={isBundledTickets || quantity === numberOfAvailableTickets}
          onClick={() => setQuantity(qty => Math.min(numberOfAvailableTickets, qty + 1))}
          data-testid="increase-qty"
          type="button"
          size="small"
          variant="secondary"
          leftAdornment={<Plus />}
        />
      </div>
    </Tooltip>
  </Selector>
)

QuantitySelector.propTypes = {
  quantity: PropTypes.number.isRequired,
  isBundledTickets: PropTypes.bool.isRequired,
  setQuantity: PropTypes.func.isRequired,
  numberOfTicketsInListing: PropTypes.number.isRequired,
  showScarcityAlert: PropTypes.bool.isRequired,
  numberOfAvailableTickets: PropTypes.number.isRequired,
  t: PropTypes.func.isRequired,
  numberOfTicketsStillForSale: PropTypes.number.isRequired,
}

export default QuantitySelector
